import type { FC } from "react";
import React from "react";
import { Button, Flex } from "@edreamsodigeo/prisma-design-system";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import type { LightBoxFooterButtonsProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/contracts";

export const LightboxFooterButtonsMobile: FC<LightBoxFooterButtonsProps> = ({
  onClose,
  openPrimePage,
}) => {
  const { t } = useTranslation();
  return (
    <Flex flexDirection={"column"} mt={"1x_big"} mb={"1x_small"} width={"100%"}>
      <Flex mb={"base"}>
        <Button onClick={onClose} fullWidth>
          {t("lightboxPrimeRevampDesktop.primaryButton")}
        </Button>
      </Flex>
      <Flex>
        <Button type={"secondary"} onClick={openPrimePage} fullWidth>
          {t("lightboxPrimeRevampDesktop.secondaryButton")}
        </Button>
      </Flex>
    </Flex>
  );
};
